import React from 'react';

const AdminProductCard = ({ product, onEdit, onDelete }) => {
  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow">
      <div className="h-32 bg-gradient-to-r from-green-100 to-yellow-50 flex items-center justify-center overflow-hidden">
        {product.image_url ? (
          <img src={product.image_url} alt={product.name} className="h-full w-full object-cover" />
        ) : (
          <span className="text-5xl">{product.emoji}</span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-bold text-gray-800">{product.name}</h3>
        <p className="text-sm text-gray-600 mb-2 line-clamp-2">{product.description}</p>
        <div className="flex justify-between items-center">
          <span className="text-green-600 font-medium">${product.price}</span>
          <div className="flex space-x-2">
            <button 
              onClick={() => onEdit(product)}
              className="p-1 text-blue-500 hover:text-blue-700 transition-colors"
            >
              ✏️
            </button>
            <button 
              onClick={() => onDelete(product.id)}
              className="p-1 text-red-500 hover:text-red-700 transition-colors"
            >
              🗑️
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProductCard;